import React, { useState } from 'react';
import type { HilPresentationAction } from '@bizfirst/hil-types';
import { HilActionBar } from '../actions/HilActionBar';

interface ApprovalStepRendererProps {
  promptMessage: string | null;
  summaryText: string | null;
  actions: HilPresentationAction[];
  requireReason?: boolean;
  disabled?: boolean;
  onAction: (action: HilPresentationAction, comment: string, reason: string) => void;
}

export function ApprovalStepRenderer({
  promptMessage,
  summaryText,
  actions,
  requireReason,
  disabled,
  onAction,
}: ApprovalStepRendererProps): React.JSX.Element {
  const [comment, setComment] = useState('');
  const [reason, setReason] = useState('');

  const needsReason = (action: HilPresentationAction) => action.RequiresReason || requireReason;

  const handleAction = (action: HilPresentationAction) => {
    if (needsReason(action) && !reason.trim()) return;
    onAction(action, comment, reason);
  };

  return (
    <div className="hil-step-content">
      {promptMessage && <p className="hil-prompt">{promptMessage}</p>}
      {summaryText && <p className="hil-description">{summaryText}</p>}
      <div>
        <label className="hil-label" htmlFor="hil-comment">Comment (optional)</label>
        <textarea
          id="hil-comment"
          className="hil-textarea"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="Add a comment..."
          disabled={disabled}
        />
      </div>
      {actions.some(a => a.RequiresReason || requireReason) && (
        <div>
          <label className="hil-label" htmlFor="hil-reason">Reason *</label>
          <textarea
            id="hil-reason"
            className="hil-textarea"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Provide a reason..."
            disabled={disabled}
          />
        </div>
      )}
      <HilActionBar actions={actions} onAction={handleAction} disabled={disabled} />
    </div>
  );
}
